// extracted by mini-css-extract-plugin
export default {"info-item":"InfoItem_info-item__tjqcv"};